import { TASK_STATUS } from "./taskStatus";
export default {
    [TASK_STATUS.PENDING]: "text-gray-400",
    [TASK_STATUS.CANCELLED]: "text-danger-500",
    [TASK_STATUS.IN_PROGRESS]: "text-primary-400",
    [TASK_STATUS.ERROR]: "text-danger-300",
    [TASK_STATUS.COMPLETED]: "text-success-500"
};
